module.exports = __webpack_public_path__ + "static/img/2_western_eastern_japan.63626ae4.png";